// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import { Spin, Table, Tag } from 'antd';
import DraggableBodyRow from './drag_and_drop';

// CUSTOM
import { tableYScroll, tableSize } from '../settings';

// CSS
import './search_table.css';

class ExamTable extends React.Component {
	state = { currentPage: 1 };

	onInternalPageChange = (page) => {
		this.setState({ currentPage: page });
		// forward to parent if provided
		const { onPaginationChange } = this.props;
		if (onPaginationChange) onPaginationChange(page);
	};
	
	moveRow = (dragIndex, hoverIndex) => {
		const { onDragAndDropRow, data, pageSize } = this.props;
		const { currentPage } = this.state;

		// compute global indices (table index is relative to current page)
		const pageOffset = (currentPage - 1) * (pageSize || data.length);
		const dragIndexGlobal = pageOffset + dragIndex;
		const hoverIndexGlobal = pageOffset + hoverIndex;

		const dragRow = data[dragIndexGlobal];

		const updatedData = update(data, {
			$splice: [[dragIndexGlobal, 1], [hoverIndexGlobal, 0, dragRow]]
		});

		onDragAndDropRow(updatedData);
	};

	render() {
		const { data, pageSize, loading = false, onRowDblClick } = this.props;
		
        const makeLocaleSorter = (field) => (a, b) => {
            const prev = String(a[field] || '');
            const next = String(b[field] || '');
            return prev.localeCompare(next);
        };

		const columns = [
			{
				title: 'ID',
				dataIndex: 'examRequestID',
				width: 100
			},
			{
				title: 'EXAM REQUEST NAME',
				dataIndex: 'examRequestName',
				width: 370,
				sorter: makeLocaleSorter('examRequestName') 
				// sorter: (a, b) => {
				// 	const prev = a.examRequestName || '';
				// 	const next = b.examRequestName || '';

				// 	return prev.localeCompare(next);
				// },
			},
			{
				title: 'EXAM REQUEST CODE',
				dataIndex: 'examRequestCode',
				width: 300,
				sorter: makeLocaleSorter('examRequestCode')
				// sorter: (a, b) => {
				// 	const prev = a.examRequestCode || '';
				// 	const next = b.examRequestCode || '';

				// 	return prev.localeCompare(next);
				// },
			},
			{
				title: 'Loinc',
				dataIndex: 'examRequestLoinc',
				width: 250,
				sorter: makeLocaleSorter('examRequestLoinc')
				// sorter: (a, b) => {
				// 	const prev = a.examRequestLoinc || '';
				// 	const next = b.examRequestLoinc || '';

				// 	return prev.localeCompare(next);
				// },
			},
			{
				title: 'INTEGRATION CODE',
				dataIndex: 'examRequestIntegrationCode',
				width: 220,
				sorter: makeLocaleSorter('examRequestIntegrationCode')
				// sorter: (a, b) => {
				// 	const prev = a.examRequestIntegrationCode || '';
				// 	const next = b.examRequestIntegrationCode || '';

				// 	return prev.localeCompare(next);
				// },
			},
			// {
			// 	title: 'SORT',
			// 	dataIndex: 'examRequestSort',
			// 	width: 220,
			// 	...(enableSorting ? { sorter: makeLocaleSorter('examRequestSort') } : {})
			// 	// sorter: (a, b) => {
			// 	// 	const prev = a.examRequestSort || '';
			// 	// 	const next = b.examRequestSort || '';

			// 	// 	return prev.localeCompare(next);
			// 	// },
			// },
			{
				title: 'STATUS',
				dataIndex: 'examRequestIsActive',
				width: 100,
				render: active => (
					<Tag color={active === 0 ? 'red' : 'green'}>{active === 0 ? 'INACTIVE' : 'ACTIVE'}</Tag>
				),
			},
		];

		const components = {
			body: {
				row: (props) => <DraggableBodyRow {...props} moveRow={this.moveRow} />,
			},
		};

		return (
			<div style={{ marginTop: 20 }}>
				<Spin spinning={loading} tip="Loading...">
					<DndProvider backend={HTML5Backend}>
					<Table
						className="ser-search-table"
						size={tableSize}
						// pagination={{ pageSize, showSizeChanger: false, onChange: onPaginationChange }}
						pagination={{ pageSize, showSizeChanger: false, onChange: this.onInternalPageChange }}
						columns={columns}
						dataSource={data}
                        components={components}
						// scroll={{ y: tableYScroll }}
						rowKey={record => record.examRequestID}
						onRow={(record, index) => ({
							index,
							moveRow: this.moveRow,
							onDoubleClick: () => onRowDblClick(record),
						})}
					/>
					</DndProvider>
				</Spin>
			</div>
		);
	}
}

ExamTable.propTypes = {
	data: PropTypes.arrayOf(
		PropTypes.shape({
			examRequestID: PropTypes.any.isRequired,
			examRequestName: PropTypes.string.isRequired,
			examRequestCode: PropTypes.string,
			examRequestLoinc: PropTypes.string,
			examRequestIntegrationCode: PropTypes.string,
			examRequestSort: PropTypes.any.isRequired,
		}),
	).isRequired,
	pageSize: PropTypes.number.isRequired,
	loading: PropTypes.bool.isRequired,
	onRowDblClick: PropTypes.func.isRequired,
	onPaginationChange: PropTypes.func.isRequired,
	onDragAndDropRow: PropTypes.func.isRequired,
};

ExamTable.defaultProps = {
	enableSorting: true,
};

export default ExamTable;
